import React from 'react';
import SearchBar from './components/SearchBar';
import QuickFilters from './components/QuickFilters';
import Actions from './components/Actions';
import { ToolbarProps } from './types';

const Toolbar: React.FC<ToolbarProps> = ({
  searchProps,
  filtersProps,
  actionsProps,
  className = '',
}) => {
  const hasFilters = filtersProps !== undefined;
  const hasActions = actionsProps !== undefined;

  return (
    <div
      className={`flex h-12 py-2 px-4 items-center justify-between w-full ${className}`}
      data-testid='table-header'
    >
      <div className='flex items-center'>
        <div className='w-72 my-auto'>
          <SearchBar {...searchProps} />
        </div>

        {hasFilters && (
          <div className='ml-4 flex gap-x-2'>
            <QuickFilters
              filters={filtersProps.filters}
              onChange={filtersProps.onChange}
            />
          </div>
        )}
      </div>

      {hasActions && (
        <div className='w-72 flex justify-end'>
          <Actions actions={actionsProps.actions} />
        </div>
      )}
    </div>
  );
};

export default Toolbar;
